import axios from "axios";

export const tracking = (id = 0, dynId = 0, event = 'NYVS23') => {
   axios.post(`${process.env.REACT_APP_API_BASE_URL}/anlytcs/click/${id}?dyn_id=${dynId}&event=${event}`)
}
